import { makeStyles } from 'tss-react/mui';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, ContentTemplate, HtmlTrans, Tabs, Typography } from 'web-library';
import TransactionHistory from '../../../modules/subject/components/TransactionHistory';
import CoordinatorExamRegistrationsListing from './CoordinatorExamRegistrationsListing';

// TODO jss-to-tss-react codemod: usages of this hook outside of this file will not be converted.
export const useStyles = makeStyles()((theme) =>
({
  table: {
    marginBottom: theme.spacing(3),
  },
  tabsHeader: {
    '& .MuiTab-root': {
      textTransform: 'none',
    },
    marginBottom: theme.spacing(4),
    '& button': {
      maxWidth: '326px',
    },
  },
  instruction: {
    marginBottom: theme.spacing(3),
  },
}));

const CoordinatorListingTabs = () => {
  const { classes } = useStyles();
  const { t } = useTranslation();
  const [selectedTab, setSelectedTab] = useState(0);

  const onChangeTab = (event: any, newValue: number) => {
    setSelectedTab(newValue);
  };

  const tabs = [t('exam->>ViewRegisteredExamsListing.RegisteredApplications')];

  return (
    <ContentTemplate type="full" continuous transparent>
      <Box className={classes.table}>
        <Tabs
          value={selectedTab}
          indicatorColor="primary"
          textColor="primary"
          onChange={onChangeTab}
          ariaLabel="Application Status tabs"
          className={classes.tabsHeader}
          // @ts-ignore
          tabs={tabs}
        />
        {selectedTab === 0 && (
          <>
            <Typography className={classes.instruction} variant="body1">
              <HtmlTrans i18nKey="exam->>ViewRegisteredExamsListing.ExamRegistrationInstruction" />
            </Typography>
            <CoordinatorExamRegistrationsListing />
          </>
        )}
        {selectedTab === 1 && <TransactionHistory />}
      </Box>
    </ContentTemplate>
  );
};

export default CoordinatorListingTabs;
